export default __webpack_public_path__ + "static/media/IMG_1111.c7117e3f.JPG";